(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["farmers-mockup-preview"] && !Shopify.designMode) return;
  try {
    
class FarmersMockupPreview extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.addEventListener('click', event => {
      const button = event.target.closest('button[data-image]');
      if (!button || !this.contains(button)) return;
      const image = this.querySelector('[data-main-image]');
      image.src = button.dataset.image;
      image.alt = button.dataset.label;
      this.querySelector('[data-selected-label]').textContent = button.dataset.label;
      this.querySelectorAll('button[data-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    });
  }
}
if (!customElements.get('farmers-mockup-preview')) customElements.define('farmers-mockup-preview', FarmersMockupPreview);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
